/*
  Returns an object with link data, formatted for the Nav component
*/
import { get } from '../../../utils/shared/api';

const secondaryLinksArray = (linkManager, cashoutBalance) => {
  const links = [
    {
      ...linkManager.build('Content strategy'),
      icon: 'c-chess',
      children: [
        linkManager.build('Summary'),
        linkManager.build('Goals'),
        linkManager.build('Audiences'),
        linkManager.build('Voice & style'),
        linkManager.build('Pillars'),
        linkManager.build('Content plan'),
        linkManager.build('Distribution'),
        linkManager.build('SEO keywords')
      ]
    },
    {
      ...linkManager.build('Financials'),
      icon: 'c-money',
      children: [linkManager.build('Publication activity'), linkManager.build('Transactions')]
    },
    {
      icon: 'gear',
      ...linkManager.build('Settings'),
      children: [
        [
          linkManager.build('Brief templates'),
          linkManager.build('Content portals'),
          linkManager.build('Content request forms'),
          linkManager.build('Custom fields'),
          linkManager.build('Integrations'),
          linkManager.build('Pitch guidelines'),
          linkManager.build('Tags'),
          linkManager.build('Workflow templates')
        ],
        [linkManager.build('Organization settings')]
      ]
    },
    {
      name: 'Support',
      path: 'https://support.contently.com/',
      icon: 'c-question',
      children: [
        {
          name: 'Help center',
          path: 'https://support.contently.com/'
        }
      ]
    },
    {
      ...linkManager.build('Messages'),
      icon: 'messages',
      noticeRequest: () =>
        get('/messages/unread_message_count', false).then(
          response => !!response.unread_message_count
        )
    }
  ];

  cashoutBalance !== '$0' && links.unshift({ name: cashoutBalance, path: '/account/activity' });

  return links;
};

export default (linkManager, onIaVersionChange, cashoutBalance) => ({
  primaryLinks: [
    linkManager.build('Tasks'),
    linkManager.build('Calendar'),
    linkManager.build('Campaigns'),
    linkManager.build('Drafts'),
    {
      ...linkManager.build('Ideation'),
      children: [linkManager.build('Pitches'), linkManager.build('Content requests')]
    },
    {
      ...linkManager.build('Content'),
      children: [
        [
          linkManager.build('All stories'),
          linkManager.build('Unassigned'),
          linkManager.build('In progress'),
          linkManager.build('Completed')
        ],
        [linkManager.build('Digital assets')]
      ]
    },
    linkManager.build('Analytics'),
    {
      ...linkManager.build('People'),
      children: [
        linkManager.build('Talent'),
        linkManager.build('User management'),
        linkManager.build('User roles')
      ]
    }
  ],
  createLinks: [
    [
      linkManager.build('Story'),
      linkManager.build('Recurring story'),
      linkManager.build('Upload story')
    ],
    [linkManager.build('Pitch'), linkManager.build('Pitch request')],
    [linkManager.build('Event')],
    [linkManager.build('User')],
    [linkManager.build('Campaign')],
    [linkManager.build('Talent search')],
    [linkManager.build('Draft')]
  ],
  secondaryLinks: secondaryLinksArray(linkManager, cashoutBalance),
  userLinks: [
    linkManager.build('Your activity'),
    linkManager.build('Password'),
    linkManager.build('Email'),
    linkManager.build('Profile'),
    [linkManager.build('Portfolio')],
    [linkManager.build('Switch to Nav V1', () => onIaVersionChange('V1'))],
    [linkManager.build('Sign out')]
  ]
});



// WEBPACK FOOTER //
// ./app/javascript/app/components/nav/ia_map_v2.js